import { useEffect, useState } from "react";
import EmLoader from "./EmLoader";
import { useResolvedDark } from "../../ThemeProvider/ThemeContext";

// Brand loader centered over a chart area while its data is being fetched.
// The parent must be positioned (relative/absolute). `dim` adds a translucent
// scrim for charts that keep stale data visible underneath. `maxMs` fades the
// loader out early (even if the fetch is still running) for charts that are
// already drawn behind it, so it never lingers over finished content.
function ChartLoader({ label = "Loading chart", dim = false, maxMs, isDark: isDarkProp }) {
  const isDark = useResolvedDark(isDarkProp);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!maxMs) return undefined;
    const timer = window.setTimeout(() => setHidden(true), maxMs);
    return () => window.clearTimeout(timer);
  }, [maxMs]);

  return (
    <div
      className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
      style={{
        zIndex: 5,
        pointerEvents: "none",
        opacity: hidden ? 0 : 1,
        transition: "opacity 0.18s ease-out",
        background: dim
          ? isDark
            ? "rgba(0,0,0,0.35)"
            : "rgba(255,255,255,0.55)"
          : "transparent",
      }}
    >
      <EmLoader size="lg" label={label} />
    </div>
  );
}

export default ChartLoader;
